import { H3 } from '@berlitz/globals'
import styled from 'styled-components'

export const TextAreaLabel = styled.p`
  margin-bottom: ${({ theme }) => theme.space.xs}}
  font-size: ${({ theme }) => theme.fontSize.xs};
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  color: ${({ theme }) => theme.colors.text01}
`

export const Box = styled.div`
  ${H3} {
    font-weight: ${({ theme }) => theme.fontWeight.bold};
  }

  span {
    line-height: ${({ theme }) => theme.lineHeight.lg};
    letter-spacing: 0.56px;
  }

  button {
    padding-top: ${({ theme }) => theme.space.xs};
    padding-bottom: ${({ theme }) => theme.space.xs};
    margin-right: ${({ theme }) => theme.space.xs};
  }
`

export const ActionContainer = styled.div`
  display: flex;
  justify-content: center;
`
